import apiClient from '../config/api';

class AIDashboardService {
  /**
   * Send a chat message to the AI backend
   * @param {string} message 
   * @param {Array} context - Previous chat messages
   * @returns {Promise} { reply, chartConfig, actions, followUp }
   */
  async sendChat(message, context = []) {
    // Input sanitization
    const sanitizedMsg = message?.trim();
    if (!sanitizedMsg) throw new Error("Empty message");
    const truncatedMsg = sanitizedMsg.substring(0, 500).replace(/<[^>]*>?/gm, '');

    try {
      const response = await apiClient.post('/ai-dashboard/chat', {
        message: truncatedMsg,
        context: context
      });
      return response.data;
    } catch (error) {
      console.error('AI Chat Error:', error);
      throw error;
    }
  }

  /**
   * Fetch KPI summary for Layer 1
   */
  async getKpiSummary(plantId) {
    try {
      const params = plantId ? { plantId } : {};
      const res = await apiClient.get('/ai-dashboard/kpi-summary', { params });
      return res.data;
    } catch (error) {
      console.error('KPI Summary Error:', error);
      throw error;
    }
  }

  /**
   * Fetch active AI insights for Layer 2
   */
  async getInsights(plantId, days = 7) {
    try {
      const params = { days, ...(plantId && { plantId }) };
      const res = await apiClient.get('/ai-dashboard/insights', { params });
      return res.data?.insights || [];
    } catch (error) {
      console.error('AI Insights Error:', error);
      return [];
    }
  }
}

export const aiDashboardService = new AIDashboardService();
